/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Sets_Nav_LabelInputs */

const en_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag sets`)
};

const fr_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensembles de tags`)
};

const de_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etikettensätze`)
};

const it_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set di tag`)
};

const ru_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наборы тегов`)
};

const es_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de etiquetas`)
};

const zh_cn2_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签集`)
};

const ja_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグセット`)
};

const hi_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग सेट`)
};

const pt_pt2_tags_manager_sets_nav_label = /** @type {(inputs: Tags_Manager_Sets_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de etiquetas`)
};

/**
* | output |
* | --- |
* | "Tag sets" |
*
* @param {Tags_Manager_Sets_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_sets_nav_label = /** @type {((inputs?: Tags_Manager_Sets_Nav_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Sets_Nav_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_sets_nav_label(inputs)
	if (locale === "de") return de_tags_manager_sets_nav_label(inputs)
	if (locale === "it") return it_tags_manager_sets_nav_label(inputs)
	if (locale === "ru") return ru_tags_manager_sets_nav_label(inputs)
	if (locale === "es") return es_tags_manager_sets_nav_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_sets_nav_label(inputs)
	if (locale === "ja") return ja_tags_manager_sets_nav_label(inputs)
	if (locale === "hi") return hi_tags_manager_sets_nav_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_sets_nav_label(inputs)
	return en_tags_manager_sets_nav_label(inputs)
});